import queryString from "query-string";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import DataTable from "../../Tabels/Tabel";
import { Divider, Text } from "theme-ui";
import plus from "../../assets/images/Icon/plus.svg";

import { TabelHeadingTxt } from "../../Text/TabelCommonTxt";
import { ColumnDef } from "@tanstack/react-table";
import TableActions from "../Roles/TableActions";
import { getApiEndPoint } from "../../../utils/GenerateQueryString";
import { getAllTeamsByUser } from "../../../store/actions/user.action";

const YourTeam = () => {
    const { loader, teamByUser, userData } = useSelector((state: any) => state.user);
    console.log('chk176', teamByUser?.data);

    const { paginations } = useSelector((state: any) => state.pagination);
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams({
        currentPage: "1",
        limit: "15",
    });
    const limit = parseInt(searchParams.get('limit') || "15");
    const currentPage = parseInt(searchParams.get('currentPage') || "1");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState<boolean>(true);

    useEffect(() => {
        let apiEndPoint = getApiEndPoint({ limit, currentPage }, location.search, columns?.map((val: any) => ({ accessorKey: val.accessorKey, filterType: val.filterType })) || [])

        dispatch(getAllTeamsByUser(apiEndPoint))
        setRefresh(false);
    }, [refresh, location?.search, limit, currentPage])
    const columns = useMemo<ColumnDef<any>[]>(() => [
        {
            header: 'No',
            enableColumnFilter: false,
            accessorKey: "no",
            cell: ({ row }) => {
                return (
                    <Text variant='Poppins14Normal24lh'>{((currentPage - 1) * limit) + row?.index + 1}</Text>
                )
            },
        },
        {
            accessorKey: "teamName",
            header: 'Team Name',
            cell: info => info.getValue(),
            enableColumnFilter: true,
            filterType: "textbox",
        },
        // {
        //     accessorKey: "teamDescription",
        //     header: 'Team Description',
        //     cell: info => info.getValue(),
        // },
        {
            header: 'Team Leader',
            accessorKey: "teamLeader",
            cell: ({ row }) => {
                const teamlead = row.original.teamLeader;
                return (
                    <Text >
                        {teamlead?.FirstName} {teamlead?.LastName}
                    </Text>
                );
            },
            filterType: 'dropdown',
            options: userData?.data?.map((val: { _id: string, FirstName: string, LastName: string }) => ({ value: val._id, label: `${val.FirstName} ${val.LastName}` }))
        },

        {
            header: 'Team Members',
            accessorKey: "members",
            cell: ({ row }) => {
                const membersCount = row.original?.members?.length;
                return (
                    <Text >
                        {membersCount}
                    </Text>
                );
            },
        },
        {
            header: 'Sub Teams',
            accessorKey: "subTeamCount",
            cell: info => info.getValue(),
        },
        {
            header: 'Accessor',
            accessorKey: "Accessor",
            enableColumnFilter: false,
            cell: ({ row }) => {
                return (
                    <TableActions row={row} editTo={`/edit-team/${row?.original?._id}`} viewTo="/my-team" showView={true} deleteMessage='Are you sure you want to delete this team?' deleteApi={`teams/deleteTeam/${row?.original?._id}`} toggleRefresh={() => setRefresh(true)} />
                )
            },
        }
    ], [teamByUser?.data]);
    const handleclick = () => {
        navigate("/create-team")
    }
    return (
        <div className='main-content'>
            <TabelHeadingTxt Title='My Team' Count={teamByUser?.data?.count} onClick={handleclick} src={plus} BtnTxt="Create Team" sx={{ backgroundColor: '#7743DB', color: 'white' }} />
            <Divider sx={{ color: '#D9D7DD' }} opacity={2} my={[3, 3, 4]} />
            <DataTable
                loader={loader}
                columns={columns}
                data={teamByUser?.data?.data || []}
                TotalLength={teamByUser?.data.count || 15}
                perPageCount={limit || 15}
                currentPage={paginations?.currentPage}
                onPerPageChange={(itemsPerPage: string) => {
                    if (searchParams?.size > 2) {
                        const parsedQuery = queryString.parse(location.search);

                        setSearchParams({
                            ...parsedQuery,
                            limit: itemsPerPage.toString(),
                        });
                    } else if (teamByUser?.count < itemsPerPage) {
                        setSearchParams({
                            currentPage: '1',
                            limit: itemsPerPage.toString(),
                        });
                    }
                    else {
                        setSearchParams({
                            currentPage: currentPage.toString(),
                            limit: itemsPerPage.toString(),
                        });
                    }

                }}
                onPageChange={(value: string) => {
                    console.log(value, "onPageChange");

                    if (searchParams?.size > 2) {
                        const parsedQuery = queryString.parse(location.search);

                        setSearchParams({
                            ...parsedQuery,
                            currentPage: value.toString(),
                        });
                    } else {
                        setSearchParams({
                            currentPage: value.toString(),
                            limit: limit.toString(),
                        });
                    }

                }}

            />
        </div>)
}

export default YourTeam